import { render, staticRenderFns } from "./DeFrame.vue?vue&type=template&id=5af6b412&"
import script from "./DeFrame.vue?vue&type=script&lang=js&"
export * from "./DeFrame.vue?vue&type=script&lang=js&"
import style0 from "./DeFrame.vue?vue&type=style&index=0&id=5af6b412&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports